export default {
  name: 'cert',
  type: 'action',
  isRequired: true
}
